import React, { useContext, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { LockOutlined, StarOutlined, LoginOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from '../../common/constants';
import { UserService } from '../../common/services';
import { useNavigate } from 'react-router-dom';
import Logo from '../../layout/logo/tigoon-connect-logo.png';
import './login.page.scss';

const Login = () => {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleLogin = async (values) => {
        try {
            setLoading(true);
            const formattedData = {
                phone: `+225${values.phone}`,
                password: values.password,
            };
            const response = await UserService.signin(formattedData);
            auth.onLogin(response, navigate);
        } catch (error) {
            const errorMessage = error.message || 'Une erreur est survenue lors de la connexion.';
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 5000,
            });
        } finally {
            setLoading(false);
        }
    };

    const features = [
        'Gestion complète des chauffeurs',
        'Suivi des courses en temps réel',
        'Tableau de bord analytique',
        'Administration sécurisée',
    ];

    return (
        <>
            <ToastContainer />
            <div className="login-container">
                {/* Panel Gauche - Branding */}
                <div className="login-branding">
                    <div className="branding-content">
                        {/* Logo dans boîte noire arrondie */}
                        <div className="logo-container">
                            <img src={Logo} alt="TIGOON Connect" />
                        </div>

                        <h1>TIGOON Connect</h1>
                        <p className="tagline">Votre partenaire mobilité VTC</p>

                        <ul className="features">
                            {features.map((feature, index) => (
                                <li key={index}>
                                    <span className="feature-icon">
                                        <StarOutlined />
                                    </span>
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <footer className="branding-footer">
                        © 2025 TIGOON Connect. Tous droits réservés.
                    </footer>
                </div>

                {/* Panel Droit - Formulaire */}
                <div className="login-form-panel">
                    <div className="login-form-container">
                        {/* Header */}
                        <div className="login-header">
                            <h2>Bienvenue ! <span className="wave-emoji">👋</span></h2>
                            <p>Connectez-vous à votre espace administrateur</p>
                        </div>

                        {/* Formulaire */}
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleLogin}
                            className="login-form"
                            autoComplete="off"
                        >
                            <Form.Item
                                label="Numéro de téléphone"
                                name="phone"
                                rules={[
                                    { required: true, message: 'Veuillez entrer votre numéro de téléphone' },
                                    { pattern: /^\d+$/, message: 'Veuillez entrer uniquement des chiffres' }
                                ]}
                            >
                                <div className="phone-input-group">
                                    <div className="country-prefix">
                                        <span className="flag"></span>
                                        <span>+225</span>
                                    </div>
                                    <Input
                                        placeholder=""
                                        size="large"
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            form.setFieldsValue({ phone: value });
                                        }}
                                    />
                                </div>
                            </Form.Item>

                            <Form.Item
                                label="Mot de passe"
                                name="password"
                                rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
                                className="password-input"
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="••••••••"
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isLoading}
                                    className="login-button"
                                    icon={<LoginOutlined />}
                                >
                                    Se connecter
                                </Button>
                            </Form.Item>

                            <div className="ssl-security">
                                <SafetyCertificateOutlined />
                                <span>Connexion sécurisée avec chiffrement SSL</span>
                            </div>
                        </Form>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
